export enum ContactFormTopic {
  Sales = 'Contact Us'
}

export enum ContactFormType {
  General = 'general',
  Support = 'technical'
}